module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\" update=\"true\"></xo-shipping-address>"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-member-components/src/select-shipping/update-shipping/template.html
 ** module id = 314
 ** module chunks = 1
 **/